// extracted by mini-css-extract-plugin
export var errorIcon = "_nv-1";
export var nameLogo = "_nv-0";